import * as defineDirectorTypes from './defineDirectorTypes'
import useDefineDirector from './useDefineDirector'
import Autocomplete from '../../../../control/autocomplete/autocomplete'
import Button from '../../../../control/button/button'
import React from 'react'
import { Grid, useMediaQuery } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { FieldArray } from 'react-final-form-arrays'
import MyAccordion from '../../../../control/accordion/accordion'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import { IconButton } from '@material-ui/core'
import useTranslate from '../../../../i18n/useTranslate'
import ModeAccordion from '../modeAccordion/ModeAccordion'

//View
const DefineDirectorView = (props: defineDirectorTypes.DefineDirectorViewType) => {
    const {
        role,
        director,
        disabled = false,
        reqFieldForm,
        useModeAccordion,
        onClickAdd,
        onClickRemove,
        validateField,
        onChangValRole,
        onChangValDirector,
        onOpenOpt,
        handleSubmitOfficerEdit,
        onClickEdit,
        listCommittee,
        handleCancle,
    } = props

    const theme = useTheme()
    const translate = useTranslate()
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'))
    const classes = useStyles({ isMobileView })

    const renderBtnRemove = (fields: any, index: number) => {
        return (
            <Grid container item xs={12} md={2} lg={2} xl={1}>
                {isMobileView ? (
                    <Button
                        onClick={() => {
                            onClickRemove(fields, index)
                        }}
                        fullWidth
                        style={{
                            top: isMobileView ? '0px' : '4px',
                            marginBottom: isMobileView ? '10%' : '20%',
                            background: '#ff6565',
                            color: '#ffffff',
                        }}
                    >
                        <RemoveCircleIcon fontSize="default" />
                    </Button>
                ) : (
                    <IconButton
                        aria-label="remove"
                        onClick={() => {
                            onClickRemove(fields, index)
                        }}
                        className={classes.btn}
                    >
                        <RemoveCircleIcon style={{ color: '#ff6565' }} fontSize="default" />
                    </IconButton>
                )}
            </Grid>
        )
    }

    const renderChild = (disabledValue: boolean) => {
        return (
            <Grid container item justify="flex-start" spacing={2}>
                <FieldArray name="committeeInfo">
                    {({ fields }) => {
                        const lengthFields = fields?.value?.length - 1

                        return fields?.map((name, index) => (
                            <React.Fragment key={index}>
                                <Grid
                                    item
                                    xs={12}
                                    md={disabledValue ? 6 : 5}
                                    lg={disabledValue ? 6 : 5}
                                    className={classes.grid}
                                    key={`${name}.key`}
                                >
                                    <Autocomplete
                                        name={`${name}.director`}
                                        materialInputProps={{
                                            label: translate.get('LABEL.COMMITTEE_NAME'),
                                            placeholder: translate.get('LABEL.PLEASE_SELECT'),
                                            disabled: disabledValue,
                                        }}
                                        options={director}
                                        error={validateField(fields.value[lengthFields]?.director, index, lengthFields)}
                                        required={reqFieldForm[index]?.director}
                                        onChangeValue={(val) => {
                                            onChangValDirector(val, index)
                                        }}
                                        onOpenOpt={() => {
                                            onOpenOpt(index)
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    md={disabledValue ? 6 : 5}
                                    lg={disabledValue ? 6 : 5}
                                    className={classes.grid}
                                >
                                    <Autocomplete
                                        name={`${name}.role`}
                                        materialInputProps={{
                                            label: translate.get('LABEL.ROLE'),
                                            placeholder: translate.get('LABEL.PLEASE_SELECT'),
                                            disabled: disabledValue,
                                        }}
                                        options={role}
                                        error={validateField(fields.value[lengthFields]?.role, index, lengthFields)}
                                        required={reqFieldForm[index]?.role}
                                        onChangeValue={(val) => {
                                            onChangValRole(val, index)
                                        }}
                                    />
                                </Grid>

                                {lengthFields > 0 && !disabledValue && renderBtnRemove(fields, index)}
                                {!disabledValue && index === lengthFields && (
                                    <Grid container item xs={12} md={12} lg={12} justify="flex-end">
                                        <IconButton
                                            aria-label="add"
                                            onClick={() => {
                                                onClickAdd(fields)
                                            }}
                                            className={classes.btnAdd}
                                        >
                                            <AddCircleIcon color="primary" fontSize="default" />
                                        </IconButton>
                                        <div
                                            className={classes.div}
                                            onClick={() => {
                                                onClickAdd(fields)
                                            }}
                                        >
                                            {translate.get('LABEL.ADD_COMMITTEE')}
                                        </div>
                                    </Grid>
                                )}
                            </React.Fragment>
                        ))
                    }}
                </FieldArray>
            </Grid>
        )
    }

    return (
        <React.Fragment>
            {useModeAccordion ? (
                <ModeAccordion
                    title={translate.get('LABEL.ASSIGN_COMMITTEE')}
                    renderViewComponent={() => renderChild(true)}
                    renderEditComponent={() => renderChild(false)}
                    isViewMode={true}
                    onConfirm={() => handleSubmitOfficerEdit(listCommittee)}
                    onClickEdit={onClickEdit}
                    fieldNames={listCommittee}
                    onCancel={handleCancle}
                />
            ) : (
                <MyAccordion title={translate.get('LABEL.ASSIGN_COMMITTEE')}>{renderChild(disabled)}</MyAccordion>
            )}
        </React.Fragment>
    )
}

//Controller
const DefineDirector = (props: defineDirectorTypes.DefineDirectorType) => {
    const defineDirectorModel = useDefineDirector(props)
    return <DefineDirectorView {...defineDirectorModel} {...props} />
}

export default DefineDirector

const useStyles = makeStyles((theme) => ({
    btnAdd: {
        textAlign: 'right',
        color: 'blue',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    btn: {
        '&:hover': {
            backgroundColor: '#ffffff',
            boxShadow: 'none',
        },
        marginTop: (props: any) => {
            let value = '0px'
            if (props.isMobileView) {
                value = '0px'
            } else {
                value = '20px'
            }
            return value
        },
    },
    grid: {
        marginBottom: '0px',
    },
    div: {
        marginTop: '13px',
        paddingRight: '10px',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
}))
